const BASE_URL = "https://api.schoollog.in/";
export default BASE_URL;
